<template>
  <div class="row">
    <div class="col-12">
      <div class="select-seminar form-section">
        <h3>Select seminar </h3>
        <v-select @input="updateSeminar" name="seminar" :options="seminare" :get-option-label="({title, date})=>`${title}`" placeholder="Select seminar"></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import {
  createNamespacedHelpers
} from 'vuex'

const {
  mapState,
  mapActions
} = createNamespacedHelpers('extendedform')

export default {
  components: {
    vSelect
  },
  computed: {
    ...mapState(['seminare'])
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions([
      'fetchData'
    ]),
    updateSeminar (event) {
      this.$router.push({ name: 'extended-event', params: { event: event.id } })
    }
  }
}
</script>
